/* cotonluv - Skripte fuer den Judge.me-Bereich der Produktseiten (ausgelagert 15.10.2026).
   Erwartet window.pdpBwDaten = { dom, pid } und die <template>s aus snippets/pdp-stil-extra.liquid. */
/* Judge.me baut seinen Bereich erst nach dem Laden (und bei jedem Sortieren neu) auf.
   lpNachbau (pdp-fixes) ruft das hier nach jeder solchen Aenderung erneut auf:
   1. unsere zwei Zahlen unter "Kundenbewertungen" einsetzen (einmal),
   2. Versatz und Breite fuer die randlosen Trennlinien messen. */
/* Texte aus den Sprachdateien: snippets/pdp-stil-extra.liquid legt sie in pdpBwDaten.t ab.
   Deutsch steht nur als Rueckfall da. Mehrzahl: Formen one/few/many/other, Wahl per Intl.PluralRules. */
window.pdpBwText = window.pdpBwText || (function () {
  var T = (window.pdpBwDaten && window.pdpBwDaten.t) || {}, spr = document.documentElement.lang || 'de';
  function tx(k, d) { return T[k] || d; }
  tx.spr = spr;
  tx.fuell = function (s, platz, wert) { return String(s).split(platz).join(wert); };
  tx.mz = function (k, n, d) {
    var f = T[k], art = 'other';
    if (!f) return d;
    try { art = new Intl.PluralRules(spr).select(n); } catch (e) {}
    return f[art] || f.other || d;
  };
  return tx;
})();
(function () {
  var tx = window.pdpBwText;
  var vorlage = document.getElementById('pdp-bw-zahlen');
  function lauf() {
    var titel = document.querySelector('.jdgm-widget .jm-review-widget-minimal-header__title');
    if (titel && vorlage && !titel.parentElement.querySelector('.pdp-bw-zahlen')) {
      titel.insertAdjacentHTML('afterend', vorlage.innerHTML);
    }
    /* Kundenfotos laedt Judge.me in 160 px - fuer die grosse Ansicht die 640er-Fassung */
    document.querySelectorAll('.jdgm-widget .jm-media-thumbnail-list__thumbnail img[src*="width=160"]').forEach(function (b) {
      b.src = b.src.replace('width=160', 'width=640');
      if (b.srcset) b.srcset = b.srcset.replace('width=160', 'width=640').replace('width=480', 'width=1000');
    });
    /* Mehrere Kundenfotos: als Stapel mit Pfeilen (und Wischen) */
    document.querySelectorAll('.jdgm-widget .jm-review-item > .jm-stack > .jm-cluster').forEach(function (c) {
      var f = c.querySelectorAll('.jm-media-thumbnail-list__thumbnail'), n = f.length, i = 0, x0 = null;
      if (n < 2 || f[0].hasAttribute('data-bw')) return;
      c.querySelectorAll('.bw-pfeil,.bw-zahl').forEach(function (e) { e.remove(); });
      var zahl = document.createElement('span'); zahl.className = 'bw-zahl';
      function zeig() {
        f.forEach(function (e, k) { var p = (k - i + n) % n; e.setAttribute('data-bw', p < 3 ? p : 'x'); });
        zahl.textContent = (i + 1) + ' / ' + n;
      }
      function geh(d) { i = (i + d + n) % n; zeig(); }
      [['bw-zurueck', -1, tx('foto_zurueck', 'Vorheriges Foto'), 'M15 18l-6-6 6-6'], ['bw-vor', 1, tx('foto_vor', 'Nächstes Foto'), 'M9 6l6 6-6 6']].forEach(function (a) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'bw-pfeil ' + a[0]; b.setAttribute('aria-label', a[2]);
        b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="' + a[3] + '"/></svg>';
        b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); geh(a[1]); });
        c.appendChild(b);
      });
      c.appendChild(zahl);
      c.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      c.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 40) geh(dx < 0 ? 1 : -1);
      });
      zeig();
    });
    /* Auszeichnungen: Beschriftung in der Shopsprache neben jeder Judge.me-Medaille */
    var stufe = tx('stufe', { Diamond: 'Diamant', Platinum: 'Platin', Gold: 'Gold', Silver: 'Silber', Bronze: 'Bronze' });
    var art = { Authentic: tx('echt', ['Echte Bewertungen', 'nur von geprüften Käufern']), Transparent: tx('transparent', ['Transparenter Shop', 'alle Bewertungen sichtbar']) };
    document.querySelectorAll('.jdgm-widget .jm-medals__medal-link').forEach(function (a) {
      if (a.querySelector('.bw-medaille')) return;
      var t = (a.querySelector('svg') || a).getAttribute('title') || '', w = t.split(' '), s2 = stufe[w[0]] || w[0], k = art[w[1]];
      if (!k) return;
      a.insertAdjacentHTML('beforeend', '<span class="bw-medaille"><b>' + k[0] + '</b><span>' + s2 + ' · ' + k[1] + '</span></span>');
    });
    /* Andere Sprachen: Liste direkt anschliessen, Seitenzaehler gemeinsam (siehe blaettern) */
    document.querySelectorAll('.jdgm-widget .jm-review-widget__body').forEach(function (bd) {
      var os = bd.querySelector('.jm-other-languages-section');
      bd.classList.toggle('bw-gemischt', !!os);
      var hp = bd.querySelector('.jm-primary-language-pagination'), op = os && os.querySelector('.jm-other-languages-section__pagination');
      bd.classList.toggle('bw-sync', !!(hp && op && seiten(hp) >= seiten(op)));
    });
    /* Noch keine Bewertung: eigener Text statt Judge.mes "Schreiben Sie die erste Bewertung" */
    var leer = document.querySelector('.jdgm-widget .jm-no-reviews-state__text');
    if (leer && !leer.getAttribute('data-bw')) {
      leer.setAttribute('data-bw', '1');
      leer.innerHTML = '<b>' + tx('keine_titel', 'Noch keine Bewertung für dieses Produkt.') + '</b>' + tx('keine_text', 'Du hast es schon? Erzähl anderen Hundebesitzern, wie es sich bei euch macht.');
    }
    var it = document.querySelector('.jdgm-widget .jm-review-item') || leer;
    if (!it) return;
    var w = it.closest('.jdgm-widget');
    var l = Math.round(it.getBoundingClientRect().left) + 'px', b = document.documentElement.clientWidth + 'px';
    if (w.style.getPropertyValue('--bw-l') !== l) w.style.setProperty('--bw-l', l);
    if (w.style.getPropertyValue('--bw-w') !== b) w.style.setProperty('--bw-w', b);
  }
  function seiten(nav) {
    var m = 1;
    nav.querySelectorAll('.jm-pagination-controls__button--page').forEach(function (b) { m = Math.max(m, +b.textContent.trim() || 1); });
    return m;
  }
  function aktiv(nav) {
    var b = nav && nav.querySelector('.jm-pagination-controls__button--active');
    return b ? +b.textContent.trim() : 1;
  }
  /* Klick im Hauptzaehler: den Zaehler der anderen Sprachen auf dieselbe Seite bringen.
     Hat er weniger Seiten, wird der Abschnitt ab dort ausgeblendet. */
  function warteAuf(nav, alt, fertig, t0) {
    t0 = t0 || Date.now();
    var n = aktiv(document.querySelector(nav));
    if (n !== alt || Date.now() - t0 > 4000) fertig(n); else setTimeout(function () { warteAuf(nav, alt, fertig, t0); }, 120);
  }
  function blaettern(ziel, runde) {
    var os = document.querySelector('.jdgm-widget .bw-sync .jm-other-languages-section');
    var op = os && os.querySelector('.jm-other-languages-section__pagination');
    if (!op || (runde || 0) > 15) return;
    os.classList.toggle('bw-aus', ziel > seiten(op));
    var cur = aktiv(op);
    if (ziel > seiten(op) || cur === ziel) return;
    var b = [].find.call(op.querySelectorAll('.jm-pagination-controls__button--page'), function (x) { return +x.textContent.trim() === ziel; });
    if (!b) { var nv = op.querySelectorAll('.jm-pagination-controls__button--nav'); b = nv[ziel > cur ? nv.length - 1 : 0]; }
    if (!b) return;
    b.click();
    warteAuf('.jdgm-widget .jm-other-languages-section__pagination', cur, function () { blaettern(ziel, (runde || 0) + 1); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.jdgm-widget .bw-sync .jm-primary-language-pagination button');
    if (!b) return;
    var hp = '.jdgm-widget .jm-primary-language-pagination';
    warteAuf(hp, aktiv(document.querySelector(hp)), function (n) { blaettern(n); });
  }, true); /* Erfassungsphase: Judge.me baut den Zaehler beim Klick neu, danach waere der Knopf schon weg */
  if (window.lpNachbau) window.lpNachbau(lauf); else lauf();
  window.addEventListener('resize', lauf);
  [800, 2000, 4000].forEach(function (ms) { setTimeout(lauf, ms); });
})();
/* Kundenfotos: alle Bewertungen MIT Foto ueber Judge.mes oeffentliche Widget-Schnittstelle
   (dieselbe, die das Widget selbst nutzt) - als Leiste unter "Unsere Auszeichnungen" und eine
   eigene Grossansicht mit der zugehoerigen Bewertung. Keine Fotos -> keine Zeile. */
(function () {
  var tx = window.pdpBwText;
  var at = function (k, d) { return tx(k, d).replace(/"/g, '&quot;'); };
  var d = window.pdpBwDaten || {}, dom = d.dom, pid = d.pid;
  if (!dom || !pid) return;
  var basis = 'https://api.judge.me/reviews/reviews_for_widget?url=' + dom + '&shop_domain=' + dom + '&platform=shopify&per_page=50&sort_by=with_pictures&product_id=' + pid + '&page=';
  var fotos = null, idx = 0, lb = null;
  var pfeil = function (d) { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="' + d + '"/></svg>'; };
  var LINKS = 'M15 18l-6-6 6-6', RECHTS = 'M9 6l6 6-6 6';
  var STERN = '<svg viewBox="0 0 24 24"><path d="m12 2 3 6.6 7 .8-5.2 4.8 1.4 7L12 17.8 5.8 21.2l1.4-7L2 9.4l7-.8L12 2z"/></svg>';
  function klein(u) { return u.replace(/width=\d+/, 'width=400'); }

  function laden() {
    var liste = [], gesehen = {};
    (function hol(p) {
      fetch(basis + p).then(function (r) { return r.json(); }).then(function (j) {
        (j.primary_language_reviews || []).concat(j.other_language_reviews || []).forEach(function (r) {
          if (gesehen[r.uuid]) return; gesehen[r.uuid] = 1;
          (r.pictures_urls || []).forEach(function (u) { if (u && u.original) liste.push({ url: u.original, r: r }); });
        });
        var a = j.primary_language_pagination || {}, b = j.other_language_pagination || {};
        if (p < 4 && (p < (a.total_pages || 1) || p < (b.total_pages || 1))) hol(p + 1); else { fotos = liste; leiste(); }
      }).catch(function () { fotos = liste; leiste(); });
    })(1);
  }

  function leiste() {
    if (!fotos || !fotos.length) return;
    var kopf = document.querySelector('.jdgm-widget .jm-review-widget-minimal-header > .jm-cluster');
    if (!kopf || kopf.querySelector('.bw-galerie')) return;
    var html = '<div class="bw-galerie"><div class="bw-gal-kopf"><b>' + tx('fotos_von_kunden', 'Fotos von Kunden') + '</b><span>' + fotos.length + ' ' + tx.mz('fotos', fotos.length, fotos.length === 1 ? 'Foto' : 'Fotos') + '</span></div>'
      + '<div class="bw-gal-rahmen"><button type="button" class="bw-gal-pfeil bw-gal-zurueck" aria-label="' + at('zurueck', 'Zurück') + '" disabled>' + pfeil(LINKS) + '</button><div class="bw-gal-spur">';
    fotos.forEach(function (f, k) {
      html += '<button type="button" class="bw-gal-bild" data-i="' + k + '" aria-label="' + tx.fuell(at('foto_gross', 'Kundenfoto __N__ vergrößern'), '__N__', k + 1) + '"><img src="' + klein(f.url) + '" alt="" loading="lazy"></button>';
    });
    html += '</div><button type="button" class="bw-gal-pfeil bw-gal-vor" aria-label="' + at('weiter', 'Weiter') + '">' + pfeil(RECHTS) + '</button></div></div>';
    kopf.insertAdjacentHTML('beforeend', html);
    var g = kopf.querySelector('.bw-galerie'), spur = g.querySelector('.bw-gal-spur');
    var zur = g.querySelector('.bw-gal-zurueck'), vor = g.querySelector('.bw-gal-vor');
    /* Bildgroesse so rechnen, dass genau n ganze Bilder in die Leiste passen (kein angeschnittenes Bild) */
    function mass() {
      var W = spur.clientWidth, z = window.innerWidth < 750 ? 104 : 128, gap = 10;
      var n = Math.max(1, Math.floor((W + gap) / (z + gap)));
      var gr = (W - gap * (n - 1)) / n;
      spur.style.setProperty('--gr', gr + 'px');
      spur.bwSeite = n * (gr + gap);
      pfeile();
    }
    function pfeile() {
      zur.disabled = spur.scrollLeft < 4;
      vor.disabled = spur.scrollLeft + spur.clientWidth > spur.scrollWidth - 4;
    }
    zur.addEventListener('click', function () { spur.scrollBy({ left: -spur.bwSeite, behavior: 'smooth' }); });
    vor.addEventListener('click', function () { spur.scrollBy({ left: spur.bwSeite, behavior: 'smooth' }); });
    spur.addEventListener('scroll', pfeile, { passive: true });
    window.addEventListener('resize', mass);
    mass();
    spur.addEventListener('click', function (e) {
      var b = e.target.closest('.bw-gal-bild');
      if (b) oeffnen(+b.getAttribute('data-i'));
    });
  }

  function bauLb() {
    lb = document.createElement('div');
    lb.className = 'bw-lb';
    lb.innerHTML = '<div class="bw-lb-grund"></div><div class="bw-lb-karte" role="dialog" aria-modal="true" aria-label="' + at('kundenfoto', 'Kundenfoto') + '">'
      + '<button type="button" class="bw-lb-zu" aria-label="' + at('schliessen', 'Schließen') + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button>'
      + '<div class="bw-lb-bild"><img alt=""><button type="button" class="bw-lb-pfeil bw-lb-zurueck" aria-label="' + at('foto_zurueck', 'Vorheriges Foto') + '">' + pfeil(LINKS) + '</button>'
      + '<button type="button" class="bw-lb-pfeil bw-lb-vor" aria-label="' + at('foto_vor', 'Nächstes Foto') + '">' + pfeil(RECHTS) + '</button><span class="bw-lb-zahl"></span></div>'
      + '<div class="bw-lb-text"></div></div>';
    document.body.appendChild(lb);
    lb.querySelector('.bw-lb-grund').addEventListener('click', zu);
    lb.querySelector('.bw-lb-zu').addEventListener('click', zu);
    lb.querySelector('.bw-lb-zurueck').addEventListener('click', function () { zeigen(idx - 1); });
    lb.querySelector('.bw-lb-vor').addEventListener('click', function () { zeigen(idx + 1); });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('offen')) return;
      if (e.key === 'Escape') zu();
      if (e.key === 'ArrowLeft') zeigen(idx - 1);
      if (e.key === 'ArrowRight') zeigen(idx + 1);
    });
    var x0 = null, bild = lb.querySelector('.bw-lb-bild');
    bild.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    bild.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) zeigen(idx + (dx < 0 ? 1 : -1));
    });
  }
  function zeigen(i) {
    var n = fotos.length; idx = (i + n) % n;
    var f = fotos[idx], r = f.r;
    lb.querySelector('.bw-lb-bild img').src = f.url;
    lb.querySelector('.bw-lb-zahl').textContent = (idx + 1) + ' / ' + n;
    lb.querySelectorAll('.bw-lb-pfeil,.bw-lb-zahl').forEach(function (e) { e.style.display = n > 1 ? '' : 'none'; });
    var t = lb.querySelector('.bw-lb-text'); t.innerHTML = '';
    function el(tag, cls, txt) { var e = document.createElement(tag); e.className = cls; if (txt != null) e.textContent = txt; t.appendChild(e); return e; }
    if (r.verified_buyer) el('span', 'bw-lb-tag', tx('verifiziert', 'Verifiziert'));
    el('div', 'bw-lb-name', r.reviewer_name || tx('anonym', 'Anonym'));
    var d = r.created_at ? new Date(r.created_at).toLocaleDateString(tx.spr, { day: '2-digit', month: '2-digit', year: 'numeric' }) : '';
    el('div', 'bw-lb-meta', [r.location_country, d].filter(Boolean).join(' · '));
    var s = el('div', 'bw-lb-sterne'); s.setAttribute('aria-label', tx.fuell(tx('sterne', '__N__ von 5 Sternen'), '__N__', r.rating));
    for (var k = 1; k <= 5; k++) s.insertAdjacentHTML('beforeend', STERN.replace('<svg ', '<svg fill="' + (k <= r.rating ? '#ffb700' : '#e8e2d5') + '" '));
    if (r.title) el('div', 'bw-lb-titel', r.title);
    el('div', 'bw-lb-body').innerHTML = r.body_html || '';
  }
  function oeffnen(i) {
    if (!lb) bauLb();
    zeigen(i);
    lb.classList.add('offen');
    document.documentElement.style.overflow = 'hidden';
    lb.querySelector('.bw-lb-zu').focus();
  }
  function zu() {
    lb.classList.remove('offen');
    document.documentElement.style.overflow = '';
  }

  /* Erst laden, wenn man sich den Bewertungen naehert (800 px vorher) - wer nicht so weit
     scrollt, laedt weder die Abfrage noch die Vorschaubilder. */
  function beobachten(versuch) {
    var ziel = document.querySelector('.jdgm-widget.jdgm-review-widget') || document.querySelector('.jdgm-widget');
    if (!ziel) { if (versuch < 20) setTimeout(function () { beobachten(versuch + 1); }, 500); return; }
    if (!('IntersectionObserver' in window)) { laden(); return; }
    var io = new IntersectionObserver(function (e) {
      if (e.some(function (x) { return x.isIntersecting; })) { io.disconnect(); laden(); }
    }, { rootMargin: '800px 0px' });
    io.observe(ziel);
  }
  beobachten(0);
  /* Judge.me baut den Kopf beim Sortieren/Blaettern neu - dann die Leiste wieder einsetzen */
  if (window.lpNachbau) window.lpNachbau(leiste);
  [1500, 3500, 6000].forEach(function (ms) { setTimeout(leiste, ms); });
})();

/* "Kunden kaufen auch": wie "Zuletzt angesehen" auf den Landingpages - "Rezensionen"/"Ueberpruefung"
   -> "Bewertung(en)" und "ab" vor dem Preis bei unterschiedlich teuren Varianten. Titel bleiben VOLL. */
(function () {
  var tx = window.pdpBwText, AB = tx('ab', 'ab');
  /* Steht das Wort schon vor dem Preis? (wie frueher /^\s*ab\b/, aber fuer jede Sprache) */
  var AB_DA = new RegExp('^\\s*' + AB.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '(\\s|$)', 'i');
  function bessern(karte) {
    if (karte.getAttribute('data-bw-fertig')) return; karte.setAttribute('data-bw-fertig', '1');
    var wort = karte.querySelector('.rating-label a span');
    if (wort) { var zahl = parseInt(wort.parentNode.textContent, 10); wort.textContent = tx.mz('bewertungen', zahl, zahl === 1 ? 'Bewertung' : 'Bewertungen'); }
    var link = karte.querySelector('h3 a'), preis = karte.querySelector('.price');
    var m = link && (link.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/);
    if (preis && m && !AB_DA.test(preis.textContent)) {
      fetch('/products/' + m[1] + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
        if (p && p.price_varies && !preis.querySelector('.tpb-ab')) { var ab = document.createElement('span'); ab.className = 'tpb-ab'; ab.textContent = AB + ' '; preis.insertBefore(ab, preis.firstChild); }
      }).catch(function () {});
    }
  }
  /* Pfeile fuer die Leiste (nur im Swiper-Zustand ab 5 Produkten; bis 4 passt alles in eine Reihe) */
  var PF = function (d) { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="' + d + '"/></svg>'; };
  function pfeile() {
    var huelle = document.querySelector('[id$="__recommendations"] ul.l4cl .swiper-outer');
    var spur = huelle && huelle.querySelector('.swiper-wrapper');
    if (!spur || huelle.querySelector('.rk-pfeil')) return;
    huelle.insertAdjacentHTML('beforeend', '<button type="button" class="rk-pfeil rk-zurueck" aria-label="' + tx('zurueck', 'Zurück').replace(/"/g, '&quot;') + '">' + PF('M15 18l-6-6 6-6') + '</button><button type="button" class="rk-pfeil rk-vor" aria-label="' + tx('weiter', 'Weiter').replace(/"/g, '&quot;') + '">' + PF('M9 6l6 6-6 6') + '</button>');
    var zur = huelle.querySelector('.rk-zurueck'), vor = huelle.querySelector('.rk-vor');
    var gap = function () { return parseFloat(getComputedStyle(spur).columnGap) || 0; };
    function stand() {
      zur.disabled = spur.scrollLeft < 4;
      vor.disabled = spur.scrollLeft + spur.clientWidth > spur.scrollWidth - 4;
    }
    zur.addEventListener('click', function () { spur.scrollBy({ left: -(spur.clientWidth + gap()), behavior: 'smooth' }); });
    vor.addEventListener('click', function () { spur.scrollBy({ left: spur.clientWidth + gap(), behavior: 'smooth' }); });
    spur.addEventListener('scroll', stand, { passive: true });
    window.addEventListener('resize', stand);
    stand();
  }
  function lauf() { [].slice.call(document.querySelectorAll('[id$="__recommendations"] li.product-card')).forEach(bessern); pfeile(); }
  var s = document.querySelector('[id$="__recommendations"]');
  lauf();
  if (s && window.MutationObserver) new MutationObserver(lauf).observe(s, { childList: true, subtree: true });
})();
